module.exports = __webpack_public_path__ + "static/media/DualDinnerMenu.dd3fa4e2.pdf";